import { Injectable } from '@angular/core';
import {RecentMessage} from '../interfaces/recentMessageData';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class RecentmessageService {

  constructor(private http: HttpClient) { }

  getRecentMessages() {
      return this.http.get<any>('assets/recentMessage.json')
      .toPromise()
      .then(res => <RecentMessage[]>res.data)
      .then(data => { return data; });
  }

}
